import axios from 'axios';



/**
 * 获取手机验证码
 * @returns {json}
 */
export const getValidate = params => {
  return axios.get('/yongpai-service/api/sms/validate2',{params : params});
};

export const getDetail = params => {
  return axios.get('/web-nbcc/commodity/commodity/detail2',{params : params});
};











// WEBPACK FOOTER //
// ./src/api/whk/index.js